package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.core.util.PeriodSelection
import br.com.vvrefeicoes.portal.domain.model.ConsolidatedMonth
import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.ConsolidatedRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.statement.bodyAsText
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

class RemoteConsolidatedRepository(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val authRepository: AuthRepository,
) : ConsolidatedRepository {
    override suspend fun load(
        selection: PeriodSelection,
        unitId: String?,
        manager: String?,
        director: String?,
    ): List<ConsolidatedMonth> {
        val path = "/operational/consolidated?${panelQuery(selection, unitId, manager, director)}"
        val response = httpClient.get(baseUrl + path) { authorize() }
        if (!response.status.isSuccess()) {
            val message =
                runCatching {
                    Json { ignoreUnknownKeys = true }
                        .decodeFromString<PanelApiErrorDto>(response.bodyAsText())
                        .message
                }.getOrNull()
            error(message ?: "HTTP ${response.status.value}")
        }
        return response.body<List<ConsolidatedMonthDto>>().map { it.toDomain() }
    }

    private fun io.ktor.client.request.HttpRequestBuilder.authorize() {
        authRepository.session.value?.token?.let { token ->
            header(HttpHeaders.Authorization, "Bearer $token")
        }
    }
}

@Serializable
private data class ConsolidatedMonthDto(
    val period: PanelMonthDto = PanelMonthDto(),
    val realRevenueCents: Long = 0,
    val realExpenseCents: Long = 0,
    val plannedRevenueCents: Long = 0,
    val plannedExpenseCents: Long = 0,
)

private fun ConsolidatedMonthDto.toDomain(): ConsolidatedMonth =
    ConsolidatedMonth(
        period = MonthPeriod(period.year, period.month),
        realRevenueCents = realRevenueCents,
        realExpenseCents = realExpenseCents,
        plannedRevenueCents = plannedRevenueCents,
        plannedExpenseCents = plannedExpenseCents,
    )
